module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-collapse', {
    staticClass: "card",
    attrs: {
      "aria-id": "contentIdForA11y3"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function(props) {
        return _c('div', {
          staticClass: "card-header",
          attrs: {
            "role": "button",
            "aria-controls": "contentIdForA11y3"
          }
        }, [_c('p', {
          staticClass: "card-header-title"
        }, [_vm._v("\n                    Component\n                ")]), _vm._v(" "), _c('a', {
          staticClass: "card-header-icon"
        }, [_c('b-icon', {
          attrs: {
            "icon": props.open ? 'menu-down' : 'menu-up'
          }
        })], 1)])
      }
    }])
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.\n                    "), _c('a', [_vm._v("#buefy")]), _vm._v(".\n                ")])]), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item"
  }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_vm._v("Delete")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024acc13"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/collapse/examples/ExCardTemplate.vue
// module id = 1023
// module chunks = 19 235